'use strict';

angular.module('cloudxcmClientsApp')
  .config(['$routeProvider',function ($routeProvider) {
    $routeProvider
      .when('/admin', {
        templateUrl: 'app/admin/admin.html',
        controller: 'AdminCtrl'
      });
  }]);